const StringConstants = {
  APP_NAME: 'payments-overview-web',
  PAYMENTS_PAGE: 'Payments | Zillow Rental Manager',

  FORMATTED_BRAND_NAMES: {
    zillow: 'Zillow',
  },

  UNFORMATTED_BRAND_NAMES: {
    zillow: 'zillow',
  },
} as const;

export default StringConstants;
